import React from "react";
import "../../css/Footer/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faXTwitter,
  faWhatsapp,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { faLandmark } from "@fortawesome/free-solid-svg-icons";

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-logo">
        <img
          src={require("../img/oliva-logo.png")}
          alt="Oliva Logo"
          className="logoHeader"
        />
      </div>
      <div className="footer-info">
        <span>
          <a
            href="https://www.google.com/maps/place/Municipalidad+de+Oliva/@-32.0377192,-63.5706514,20z/data=!4m6!3m5!1s0x95cce1f9bef1e8b1:0xa7e05cb5d2218d7f!8m2!3d-32.0375935!4d-63.5703278!16s%2Fg%2F1hc6jynbm?entry=ttu&g_ep=EgoyMDI1MDUxMS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            Belgrano 292, Oliva, Córdoba
          </a>
        </span>
        <span>
          <a target="_blank" rel="noopener noreferrer" aria-label="Email">
            info@ciudaddeoliva.gob.ar
          </a>
        </span>
      </div>
      <div className="footer-social">
        <a
          href="https://www.instagram.com/munamoliva"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Museo Nacional de Malvinas"
        >
          <img
            src={require("../img/malvinas.png")}
            alt="Escudo"
            className="imgMalvinas"
          />
        </a>
        <a
          href="https://www.facebook.com/MunicipalidaddeOliva"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FontAwesomeIcon icon={faFacebook} />
        </a>
        <a
          href="https://www.instagram.com/munioliva/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a
          href="https://x.com/olivamunic"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X"
        >
          <FontAwesomeIcon icon={faXTwitter} />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=5493532436447&text=Hola%2C+me+contacto+para+realizar+una+consulta.&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <a
          href="https://www.tiktok.com/@munioliva"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FontAwesomeIcon icon={faTiktok} />
        </a>
      </div>
    </div>
    <div className="footer-copyright">
      © {new Date().getFullYear()} Todos los Derechos Reservados Municipalidad
      de Oliva | Desarrollado por NewLink Ingeniería S.A.S
    </div>
  </footer>
);

export default Footer;
